(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const accountButton = event.target;
      const bottom = Math.round(accountButton.getBoundingClientRect().bottom);
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  // Signed-in avatar lives in open shadow DOM; CSS vars cover fill/text/border color,
  // but border-width and text-decoration on the initial are not exposed — inject once.
  const ACCOUNT_AVATAR_STYLE_ID = 'simplyfun-account-avatar-style';
  function styleSignedInAccountAvatar(root) {
    if (!root || root.getElementById(ACCOUNT_AVATAR_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = ACCOUNT_AVATAR_STYLE_ID;
    style.textContent = `
      .account-button__avatar {
        border: 1px solid var(--shopify-account-signed-in-avatar-color-border, #121212) !important;
        border-radius: 50% !important;
        background-color: var(--shopify-account-signed-in-avatar-color-background, #ffffff) !important;
        box-sizing: border-box;
      }
      .account-button__avatar-initials {
        color: var(--shopify-account-signed-in-avatar-color-text, #121212) !important;
        text-decoration: none !important;
      }
    `;
    root.appendChild(style);
  }

  function walkAccountShadows(node, visit) {
    if (!node) return;
    if (node.shadowRoot) {
      visit(node.shadowRoot);
      walkAccountShadows(node.shadowRoot, visit);
    }
    for (const child of node.children || []) walkAccountShadows(child, visit);
  }

  function enhanceShopifyAccount(el) {
    if (!(el instanceof HTMLElement)) return;
    walkAccountShadows(el, styleSignedInAccountAvatar);
    const observer = new MutationObserver(() => walkAccountShadows(el, styleSignedInAccountAvatar));
    observer.observe(el, { childList: true, subtree: true });
    if (el.shadowRoot) observer.observe(el.shadowRoot, { childList: true, subtree: true });
  }

  document.querySelectorAll('shopify-account').forEach(enhanceShopifyAccount);
  customElements.whenDefined('shopify-account').then(() => {
    document.querySelectorAll('shopify-account').forEach(enhanceShopifyAccount);
  });

  } catch(e) { console.error(e); }
})();
})();
